import React from 'react';

/**
 * Section tabs used across dashboards. Styles live in index.css (.tab-bar / .tab-btn)
 * so every page's tabs look the same and are clearly distinct from page content.
 */
export const TabBar = ({ children, style }) => (
  <div className="tab-bar" role="tablist" style={style}>
    {children}
  </div>
);

export const TabBtn = ({ children, active, onClick, icon }) => (
  <button
    type="button"
    role="tab"
    aria-selected={!!active}
    className={`tab-btn${active ? ' active' : ''}`}
    onClick={onClick}
  >
    {icon}
    <span>{children}</span>
  </button>
);
